import React, { useState } from 'react'
import { supabase } from '../supabaseClient'

export default function TopNav({ active }) {
  const [open, setOpen] = useState(false)

  async function handleLogout() {
    await supabase.auth.signOut()
    window.location.href = '/login'
  }

  const links = [
    { key: 'my-events', label: 'My Events', href: '/' },
    { key: 'how-to-play', label: 'How to Play', href: '/how-to-play' },
    { key: 'account', label: 'My Account', href: '/change-password' }
  ]

  return (
    <nav className="topnav">
      <a href="/" className="topnav-logo">PREDICTA</a>

      <div className="nav-links nav-links-desktop">
        {links.map(l => (
          <a key={l.key} href={l.href} className={`nav-link ${active === l.key ? 'nav-link-active' : ''}`}>
            {l.label}
          </a>
        ))}
        <button className="nav-link nav-logout" onClick={handleLogout}>Log out</button>
      </div>

      <button
        className="nav-toggle"
        aria-label={open ? 'Close menu' : 'Open menu'}
        onClick={() => setOpen(o => !o)}
      >
        <span className={`nav-toggle-bar ${open ? 'open' : ''}`} />
      </button>

      {open && (
        <div className="nav-mobile-menu">
          {links.map(l => (
            <a
              key={l.key}
              href={l.href}
              className={`nav-mobile-link ${active === l.key ? 'nav-mobile-link-active' : ''}`}
              onClick={() => setOpen(false)}
            >
              {l.label}
            </a>
          ))}
          <button className="nav-mobile-link nav-mobile-logout" onClick={handleLogout}>Log out</button>
        </div>
      )}
    </nav>
  )
}
